import React from 'react'

export default function LoginError(props) {
    return (
        <p className="error-msj">An incorrect username/password combination was entered. You have [{props.count}] more attempts before being locked out and will need to contact the help desk at <strong>(855) 965-2472</strong>. If you need to reset your password, please click on the 'Forgot My Password' link below.  </p>
    )
}